import { brands } from 'Constants';

// Images
import AnthemBC from 'Images/Anthem_BC.png';
import AnthemBCBS from 'Images/Anthem_BCBS.png';
import AnthemHK from 'Images/Anthem_HK.png';
import EmpireBC from 'Images/Empire_BC.png';
import EmpireBCBS from 'Images/Empire_BCBS.png';

const links = {};
links[brands.BCBSNY] = {
  surveyLink:'https://survey3.medallia.com/?commshelpfulness&id=OEMSABCBS&format=Web',
  link:
    'https://www.anthem.com/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'anthem.com',
  webLink: 'https://www.anthem.com/',
  name: 'Anthem',
  logo: AnthemBCBS,
  fullname: 'Anthem Blue Cross and Blue Shield',
  privacyPolicy: 'https://anthem.com/privacy',
  legal: 'https://www.anthem.com/legal-disclosure',
  legalText:
    'Anthem Blue Cross and Blue Shield is the trade name of: In Colorado: Rocky Mountain Hospital and Medical Service, Inc. HMO products underwritten by HMO Colorado, Inc. In Connecticut: Anthem Health Plans, Inc. In Indiana: Anthem Insurance Companies, Inc. In Georgia: Blue Cross Blue Shield Healthcare Plan of Georgia, Inc. and Community Care Health Plan of Georgia, Inc. In Kentucky: Anthem Health Plans of Kentucky, Inc. In Maine: Anthem Health Plans of Maine, Inc. In Missouri (excluding 30 counties in the Kansas City area): RightCHOICE® Managed Care, Inc. (RIT), Healthy Alliance® Life Insurance Company (HALIC), and HMO Missouri, Inc. RIT and certain affiliates administer non-HMO benefits underwritten by HALIC and HMO benefits underwritten by HMO Missouri, Inc. RIT and certain affiliates only provide administrative services for self-funded plans and do not underwrite benefits. In Nevada: Rocky Mountain Hospital and Medical Service, Inc. HMO products underwritten by HMO Colorado, Inc., dba HMO Nevada. In New Hampshire: Anthem Health Plans of New Hampshire, Inc. HMO plans are administered by Anthem Health Plans of New Hampshire, Inc. and underwritten by Matthew Thornton Health Plan, Inc. In 17 southeastern counties of New York:  Anthem HealthChoice Assurance, Inc., and Anthem HealthChoice HMO, Inc.  In these same counties Anthem Blue Cross and Blue Shield HP is the trade name of Anthem HP, LLC.  In Ohio: Community Insurance Company. In Virginia: Anthem Health Plans of Virginia, Inc. trades as Anthem Blue Cross and Blue Shield, and its affiliate HealthKeepers, Inc. trades as Anthem HealthKeepers providing HMO coverage, and their service area is all of Virginia except for the City of Fairfax, the Town of Vienna, and the area east of State Route 123. In Wisconsin: Blue Cross Blue Shield of Wisconsin (BCBSWI) underwrites or administers PPO and indemnity policies and underwrites the out-of-network benefits in POS policies offered by Compcare Health Services Insurance Corporation (Compcare) or Wisconsin Collaborative Insurance Corporation (WCIC). Compcare  underwrites or administers HMO or POS policies; WCIC underwrites or administers Well Priority HMO or POS policies. Independent licensees of the Blue Cross and Blue Shield Association. Anthem is a registered trademark of Anthem Insurance Companies, Inc.'
};



links[brands.ABCBS] = {
  surveyLink:'https://survey3.medallia.com/?commshelpfulness&id=OEMSABCBS&format=Web',
  link:
    'https://www.anthem.com/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'anthem.com',
  webLink: 'https://www.anthem.com/',
  name: 'Anthem',
  logo: AnthemBCBS,
  fullname: 'Anthem Blue Cross and Blue Shield',
  privacyPolicy: 'https://anthem.com/privacy',
  legal: 'https://anthem.com/legal',
  legalText:
    'Anthem Blue Cross and Blue Shield is the trade name of: In Colorado: Rocky Mountain Hospital and Medical Service, Inc. HMO products underwritten by HMO Colorado, Inc. In Connecticut: Anthem Health Plans, Inc. In Georgia: Blue Cross Blue Shield Healthcare Plan of Georgia, Inc. In Indiana: Anthem Insurance Companies, Inc. In Kentucky: Anthem Health Plans of Kentucky, Inc. In Maine: Anthem Health Plans of Maine, Inc. In Missouri (excluding 30 counties in the Kansas City area): RightCHOICE® Managed Care, Inc. (RIT), Healthy Alliance® Life Insurance Company (HALIC), and HMO Missouri, Inc. RIT and certain affiliates administer non-HMO benefits underwritten by HALIC and HMO benefits underwritten by HMO Missouri, Inc. RIT and certain affiliates only provide administrative services for self-funded plans and do not underwrite benefits. In Nevada: Rocky Mountain Hospital and Medical Service, Inc. HMO products underwritten by HMO Colorado, Inc., dba HMO Nevada. In New Hampshire: Anthem Health Plans of New Hampshire, Inc. HMO plans are administered by Anthem Health Plans of New Hampshire, Inc. and underwritten by Matthew Thornton Health Plan, Inc. In Ohio: Community Insurance Company. In Virginia: Anthem Health Plans of Virginia, Inc. trades as Anthem Blue Cross and Blue Shield in Virginia, and its service area is all of Virginia except for the City of Fairfax, the Town of Vienna, and the area east of State Route 123. In Wisconsin: Blue Cross Blue Shield of Wisconsin (BCBSWI), underwrites or administers PPO and indemnity policies and underwrites the out of network benefits in POS policies offered by Compcare Health Services Insurance Corporation (Compcare) or Wisconsin Collaborative Insurance Corporation (WCIC). Compcare underwrites or administers HMO or POS policies; WCIC underwrites or administers Well Priority HMO or POS policies. Independent licensees of the Blue Cross and Blue Shield Association. Anthem is a registered trademark of Anthem Insurance Companies, Inc.'
};


links[brands.ABC] = {
  surveyLink:'https://survey3.medallia.com/?commshelpfulness&id=OEMSABC&format=Web',
  link:
    'https://www.anthem.com/ca/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'anthem.com/ca',
  webLink: 'https://www.anthem.com/ca/',
  name: 'Anthem',
  logo: AnthemBC,
  fullname: 'Anthem Blue Cross',
  privacyPolicy: 'https://anthem.com/privacy',
  legal: 'https://anthem.com/legal',
  legalText:
    'Anthem Blue Cross is the trade name of Blue Cross of California. Anthem Blue Cross and Anthem Blue Cross Life and Health Insurance Company are independent licensees of the Blue Cross Association. Anthem is a registered trademark of Anthem Insurance Companies, Inc.'
};



links[brands.BCNY] = {
  surveyLink:'https://survey3.medallia.com/?commshelpfulness&id=OEMSABC&format=Web',
  link:
    'https://www.anthem.com/ca/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'anthem.com/ca',
  webLink: 'https://www.anthembluecross.com/',
  name: 'Anthem',
  logo: AnthemBC,
  fullname: 'Anthem Blue Cross',
  privacyPolicy: 'https://www.anthembluecross.com/privacy',
  legal: 'https://www.anthembluecross.com/legal-disclosure',
  legalText:
    'In California Anthem Blue Cross is the trade name of Blue Cross of California, Inc.  Also serving California:  Anthem Blue Cross Life and Health Insurance Company.  In 11 northeastern counties of New York Anthem Blue Cross is the trade name of Anthem HealthChoice Assurance, Inc., and Anthem HealthChoice HMO, Inc., and Anthem Blue Cross HP is the trade name of Anthem HP, LLC.  Independent licensees of the Blue Cross Association.  Anthem is a registered trademark of Anthem Insurance Companies, Inc.'
};



links[brands.EBCBS] = {
  surveyLink:'https://survey3.medallia.com/?commshelpfulness&id=OEMSEBCBS&format=Web',
  link:
    'https://www.empireblue.com/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'empireblue.com',
  name: 'Empire',
  webLink: 'https://www.empireblue.com/',
  logo: EmpireBCBS,
  fullname: 'Empire Blue Cross and Blue Shield',
  privacyPolicy: 'https://empireblue.com/privacy',
  legal: 'https://www.empireblue.com/legal/',
  legalText:
    'Services provided by Empire HealthChoice HMO, Inc., Empire HealthChoice Assurance, Inc., and/or HealthPlus HP, LLC, Independent licensees of the Blue Cross and Blue Shield Association, an association of independent Blue Cross and Blue Shield plans.'
};

links[brands.EBC] = {
  surveyLink:'https://survey3.medallia.com/?commshelpfulness&id=OEMSEBC&format=Web',
  link:
    'https://www.empireblue.com/find-doctor/?dplid=sso.dpl.providerdirectory.search-criteria',
  website: 'empireblue.com',
  name: 'Empire',
  webLink: 'https://www.empireblue.com/',
  logo: EmpireBC,
  fullname: 'Empire Blue Cross',
  privacyPolicy: 'https://empireblue.com/privacy',
  legal: 'https://www.empireblue.com/legal/',
  legalText:
    'Services provided by Empire HealthChoice HMO, Inc., Empire HealthChoice Assurance, Inc., and/or HealthPlus HP, LLC, Independent licensees of the Blue Cross and Blue Shield Association, an association of independent Blue Cross and Blue Shield plans.'
};





export default state => {
  const brandInfo = { ...links[state.brandID] };
  if (
    state.state === 'VA' &&
    (state.groupSize === 'LG' ||
      state.groupSize === 'SG') &&
    state.brandID === 'Anthem BCBS'
  ) {
    brandInfo.legalText =
      'Anthem Blue Cross and Blue Shield is the trade name of Anthem Health Plans of Virginia, Inc. Anthem Blue Cross and Blue Shield, and its affiliate Healthkeepers, Inc., serving all of Virginia except for the City of Fairfax, the Town of Vienna, and the area east of State Route 123, are independent licensees of the Blue Cross Blue Shield Association. Anthem is a registered trademark of Anthem Insurance Companies, Inc.';
    brandInfo.logo = AnthemHK;
  }

  state.brandInfo = brandInfo;
};
